let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aAxB4")).then(() => parcelRequire('aHCWR'));